import { useToast } from "vue-toastification";
import { ref, computed } from "vue";
import store from "../../../store";
import useBase64 from "./useBase64";
import useModal from "../../../useModal";

export default function useFileUploader() {
    const toast = useToast()
    const uploaderNamespace = ref(null)
    const cropperNamespace = ref(null)
    const uploaderInputName = ref(null)
    const {
        deleteFileModal
    } = useModal()
    const {
        getBase64
    } = useBase64()

    // computed
    const file = computed(() => store.getters[`${uploaderNamespace.value}getFiles`])

    const cropper = computed(() => store.getters[`${cropperNamespace.value}getFiles`])

    const isSubmitted = computed(() => store.getters[`${uploaderNamespace.value}getIsSubmitted`])


    function MBtoBytes(sizeMB) {
        return sizeMB * 1048576
    }

    function clearFiles(fileInput) {
        fileInput.value = ''
    }

    function exceedSizeMessage(sizeLimitMB) {
        toast.error(`Presiahli ste maximálnu sumárnu veľkosť súborov ${sizeLimitMB}MB`,)
    }

    function getSumFileSize(files) {
        const fileCount = files.length
        let fileSize = 0

        for (let i = 0; i < fileCount; i++) {
            fileSize += files[i].size // get file size
        }

        return fileSize
    }

    function isSuccesfulValidation(fileInput, storeNamespace) {
        const { files } = fileInput
        const sizeLimitMB = store.getters[`${storeNamespace}/getSizeLimit`]
        const sizeLimitBytes = MBtoBytes(sizeLimitMB)
        let error = false

        // exceed summary file size
        if (getSumFileSize(files) > sizeLimitBytes) {
            exceedSizeMessage(sizeLimitMB)
            error = true
        }

        if (error) {
            clearFiles(fileInput)
        }

        return !error
    }

    async function handleFiles(event, storeNamespace) {
        const commitMethod = `${storeNamespace}SET_FILES`
        const fileInput = event.target;
        // validation
        if (!isSuccesfulValidation(fileInput, storeNamespace)) {
            return false
        }

        const files = await getBase64(fileInput.files)

        store.commit(commitMethod, files)

        return true;
    }

    // find file input data by ID 
    function uploadUploaderFiles(type) {
        const dispatchMethod = 'fileUploader/UPLOAD_FILES'

        const files = document.querySelector(`#${type}`).files[0]

        return store.dispatch(dispatchMethod, { type, files })
            .then(({ data }) => {
                const product = store.getters['product/getProduct']

                product.files[type] = data

                store.commit('product/SET_PRODUCT', product)
            })
    }

    function deleteFile() {
        deleteFileModal(() => {
            store.commit(`${uploaderNamespace.value}SET_FILES`, null)
            store.commit(`${cropperNamespace.value}SET_FILE`, null)
            store.commit(`${uploaderNamespace.value}SET_SUBMITTED`, false)
            // clear input data
            document.querySelector(`#${uploaderInputName.value}`).value = '';
        })
    }

    function editFile() {
        store.commit(`${uploaderNamespace.value}SET_SUBMITTED`, false)
    }

    function saveModified() {
        store.commit(`${uploaderNamespace.value}SET_SUBMITTED`, true)
    }

    return {
        handleFiles,
        uploadUploaderFiles,
        deleteFile,
        editFile,
        saveModified,
        uploaderNamespace,
        cropperNamespace,
        uploaderInputName,
        // computed
        file,
        cropper,
        isSubmitted,
    }
}
